import React from "react";
import { ArrowDown } from "lucide-react";
import { Text } from "../../utils/text/text";
// Whole label is the sort target, not just the arrow; hint stays faintly visible on touch since nothing hovers.
export function ThSort({ className = "", idText, sortKey, setSort, active = false, direction = "asc" }) {
    return (<button type={"button"} onClick={() => setSort(sortKey)} className={`
                group flex w-full items-center gap-1 rounded-md py-1 pr-1 text-left
                eyebrow cursor-pointer pressable focus-ring
                ${active ? "text-brand-700" : "text-gray-500 hover:text-gray-800"}
                ${className}
            `}>
            <span className={"truncate"}>
                <Text id={idText}/>
            </span>
            {/* aria-sort only works on <th>, which this button doesn't own — sort state joins the accessible name instead (DESIGN.md §14). */}
            {active && (<span className={"sr-only"}>
                    <Text id={direction === "desc" ? "sort_desc" : "sort_asc"}/>
                </span>)}
            <ArrowDown aria-hidden={"true"} className={`
                    h-3.5 w-3.5 shrink-0 transition-[opacity,rotate] duration-150 ease-out-soft
                    ${active ? "opacity-100" : "opacity-0 group-hover:opacity-40 pointer-coarse:opacity-30"}
                    ${active && direction === "desc" ? "rotate-180" : ""}
                `}/>
        </button>);
}
//# sourceMappingURL=thSort.jsx.map